module.exports = __webpack_public_path__ + "img/Strip-Front-B2-Ce-Jc.69a38c79.png";